export default function($){
  $('.js-tabs').easytabs();
}
